import { Grid, Typography, Link, Card } from '@material-ui/core'
import React from 'react'
import { Skeleton } from '@material-ui/lab'

import { Panel } from '../common/Layout'
import PanelHeader from '../common/PanelHeader'

export const PanelEmailPreferences = ({ isLoadingEmailPreferenceUrl, emailPreferenceUrl }) => (
  <Card>
    {isLoadingEmailPreferenceUrl ? (
      <SkeletonPanelEmailPreference />
    ) : (
      <Panel>
        <PanelHeader title="Email Preferences" />
        <Grid container>
          <Grid item xs={9}>
            <Typography variant="body2">
              Update email preferences{' '}
              <Link href={emailPreferenceUrl} target="_blank">
                here.
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </Panel>
    )}
  </Card>
)
export default PanelEmailPreferences

const SkeletonPanelEmailPreference = () => (
  <>
    <Skeleton height={40} width="100%" />
    <Skeleton height={56} width="100%" />
    <Skeleton height={56} width="100%" />
  </>
)
